import { useState } from "react";
import { api } from "../api/client";
import { useT } from "../i18n";

const KINDS = ["other_solution", "wrong_solution", "wrong_position", "other"] as const;

/** §10.3: "Report a problem"; the move list is attached by the server. */
export function ReportDialog({ exerciseId, attemptId, onClose }: { exerciseId: number; attemptId?: number | null; onClose: () => void }) {
  const t = useT();
  const [kind, setKind] = useState<(typeof KINDS)[number]>("other_solution");
  const [text, setText] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "sent" | "error">("idle");
  async function send() {
    setState("busy");
    try {
      await api(`/exercises/${exerciseId}/report`, { body: { kind, text, attempt_id: attemptId ?? null } });
      setState("sent");
      setTimeout(onClose, 1200);
    } catch {
      setState("error");
    }
  }
  return (
    <div className="overlay" onClick={onClose}>
      <div className="dialog stack" onClick={(e) => e.stopPropagation()} role="dialog" aria-label={t("report.title")}>
        <h2 style={{ color: "var(--text)" }}>{t("report.title")}</h2>
        {state === "sent" ? (
          <p className="ok">{t("report.thanks")}</p>
        ) : (
          <>
            {KINDS.map((k) => (
              <label key={k} className="check">
                <input type="radio" name="kind" checked={kind === k} onChange={() => setKind(k)} />
                {t(`report.${k}`)}
              </label>
            ))}
            <label>
              {t("report.text")}
              <textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} maxLength={4000} />
            </label>
            {state === "error" && <p className="err small">{t("err.generic")}</p>}
            <div className="row" style={{ justifyContent: "flex-end" }}>
              <button className="ghost" onClick={onClose}>{t("common.cancel")}</button>
              <button className="primary" disabled={state === "busy"} onClick={send}>{t("report.send")}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
